import { Rarity } from '#src/__generated__/globalTypes.ts';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { EssenceBalance } from '#src/components/balance/EssenceBalance/index.tsx';
import { GemsBalance } from '#src/components/commonGame/GemsBalance/index.tsx';
import { useConfigContext } from '#src/contexts/config/index.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { getCommonCardShardsCount } from '#src/lib/currentUser/index.tsx';

type Props = { color?: 'tertiary' };
export const SeriesBalance = ({ color }: Props) => {
  const { currentUser } = useCurrentUserContext();
  const { cardSet } = useConfigContext();
  const currentCardSet = cardSet?.currentSet ?? cardSet?.nextSet;

  return (
    <Horizontal>
      <GemsBalance
        balance={currentUser?.gemsBalances[0]?.amount || 0}
        color={color}
      />
      {!!currentCardSet && (
        <EssenceBalance
          value={getCommonCardShardsCount(currentUser, currentCardSet.slug)}
          rarity={Rarity.common}
          cardSet={currentCardSet}
          color={color}
        />
      )}
    </Horizontal>
  );
};
